/**
 * 资讯相关接口
 */
import {baseUrl, pbrAxios} from '../../common/js/pbrAxios'

/**
 * 资讯详情
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.lang:en:英文  cn：中文  其他：中文
 *    @param {String}params.id: 资讯id
 *    @param {Number}params。isOrigin:0：不是原文 1：原文   获取详情时不传,获取原文时传值为 1
 *    @param {Number}paramas.userId: 用户id
 * @returns {AxiosPromise<any>}
 */
const queryInfoDetail = params => {
  return pbrAxios.get('/front/article/getArticleDetail', params)
}

/**
 * 保存操作历史记录调用这个接口
 * @param params
 *  @param {String}params.subType:  riskEven  风险事件，riskArticle风险资讯 ， businessArticle  商机资讯，projectArticle 项目资讯
 * @returns {AxiosPromise<any>}
 */
const saveRiskSearchHistory = params => pbrAxios.post('/front/article/saveRiskSearchHistory', params)

/**
 * 风险事件详情
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.lang:en:英文  cn：中文  其他：中文
 *    @param {String}params.id: 资讯id
 *    @param {Number}paramas.userId: 用户id
 * @returns {AxiosPromise<any>}
 */
const queryRiskDetail = params => {
  return pbrAxios.get('/front/risk/queryDetail', params)
}

/**
 * 热词
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.lang:en:英文  cn：中文  其他：中文
 * @returns {AxiosPromise<any>}
 */
const queryGHotword = params => {
  return pbrAxios.post('/front/article/ghotword', params)
}

/**
 * 资讯热点
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.lang:en:英文  cn：中文  其他：中文
 * @returns {AxiosPromise<any>}
 */
const queryHotSpot = params => {
  return pbrAxios.get('/front/article/hotSpot', {params})
}

/**
 * 获取搜索记录表(目前只有项目资讯)
 *
 * @param {Object}params - 请求参数
 *    @param {Number}params.pageNo:页号
 *    @param {Number}params.pageSize: 每页条数
 *    @param {String}params。type: projectArticle businessArticle riskArticle riskEven 默认为projectArticle
 *    @param {Number}paramas.userId: 用户id
 * @returns {AxiosPromise<any>}
 */
const queryHistorySearch = params => {
  return pbrAxios({
    url: '/front/article/getHistorySearch', // 接口路径
    method: 'get',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  // return pbrAxios.get('/front/article/getHistorySearch', { params })
}

/**
 * 搜索历史置顶(目前只有项目资讯)
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.id: 资讯id
 *    @param {Number}params。isUp:0：是否置顶
 *    @param {Number}paramas.userId: 用户id
 * @returns {AxiosPromise<any>}
 */
const updateHistorySearch = params => {
  return pbrAxios({
    url: '/front/article/updateHistorySearch', // 接口路径
    method: 'get', //put -> get 2021-12-13
    params,
    // transformRequest: [function(data) {
    //     let ret = ''
    //     for (let it in data) {
    //         ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //     }
    //     return ret
    // }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })

  // return pbrAxios.put('/front/article/updateHistorySearch', params, {
  //         headers: {
  //             'Content-Type': 'multipart/form-data'
  //         }
  //     })
  // return pbrAxios.put('/front/article/updateHistorySearch', params)
}

/**
 * 删除搜索历史(目前只有项目资讯)
 *
 * @param {Object}params - 请求参数
 *    @param {String}params.id: 资讯id
 *    @param {Number}paramas.userId: 用户id
 * @returns {AxiosPromise<any>}
 */
const deleteHistorySearch = params => {
  return pbrAxios.post('/front/article/deleteHistorySearch', { params })
}

/**
 * 前端-项目导出excel列表
 * @param params
 *  @param {String} params.selections: 选中需要下载的ID, id之间以,逗号分隔 可选(为空则全部下载)
 *  @param {String} params.from: 语言
 * @returns {AxiosPromise<any>}
 */
const exportListExcel = params => pbrAxios.get('/front/article/exportListXls',{params})
const exportInfoListExcelUrl = `/front/article/exportListXls`
/**
 * 前端-项目导出excel列表
 * @param params
 *  @param {String} params.id: 项目id
 *  @param {String} params.from: 语言
 * @returns {AxiosPromise<any>}
 */
const exportDetailWord = params => pbrAxios.get('/front/article/exportDetailWord',{params})
const exportInfoDetailWordUrl = `/front/article/exportDetailWord`

export default {
  queryInfoDetail,
  queryRiskDetail,
  queryGHotword,
  queryHotSpot,
  queryHistorySearch,
  updateHistorySearch,
  deleteHistorySearch,
  exportListExcel,
  exportDetailWord,
  exportInfoListExcelUrl,
  exportInfoDetailWordUrl,
  saveRiskSearchHistory
}
